module.exports = __webpack_public_path__ + "img/icon03.82b00b27.png";